import { render, staticRenderFns } from "./PhePlateNumberPicker.vue?vue&type=template&id=64d5aca7&"
import script from "./PhePlateNumberPicker.vue?vue&type=script&lang=js&"
export * from "./PhePlateNumberPicker.vue?vue&type=script&lang=js&"
import style0 from "./PhePlateNumberPicker.vue?vue&type=style&index=0&id=64d5aca7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports